<template>
  <div class="bg-[#f7fbfe]">
    <TsContentPage />
    <TsCategoryHomeMenu />
  </div>
</template>

<script setup lang="ts">
import defaultSeoData from '~/json/default_seo_data.json';

const TsContentPage = defineAsyncComponent(
    () => import('~/components/builder/TsContentPage.vue')
);

const TsCategoryHomeMenu = defineAsyncComponent(
    () => import('~/components/organisms/TsCategoryHomeMenu.vue')
);

const route = useRoute();
const runtimeconfig = useRuntimeConfig();
const requestURL = useRequestURL();

useHead({
  title: defaultSeoData.title,
  meta: [
    { name: 'title', content: defaultSeoData.title },
    { name: 'description', content: defaultSeoData.description },
    { property: 'og:title', content: defaultSeoData.title },
    { property: 'og:description', content: defaultSeoData.description },
    { property: 'og:image', content: defaultSeoData.image },
    { property: 'og:type', content: defaultSeoData.type },
    { property: 'og:url', content: `${requestURL.origin}${route.fullPath}` },
    { property: 'og:site_name', content: 'Gereedschap voor de professional - Toolstation' },
    { name: 'twitter:card', content: 'summary_large_image' }, 
    { name: 'twitter:title', content: defaultSeoData.title }, 
    { name: 'twitter:description', content: defaultSeoData.description },
    { name: 'twitter:image', content: `${useRuntimeConfig().public.assetBaseUrl}/${defaultSeoData.image}` },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${requestURL.origin}${route.path}`,
    }
  ]
});

schemaHomePage({
  urlHost: requestURL.host,
  completeUrl: route.fullPath,
}, runtimeconfig)
</script>